import Landing from './Landing/Landing.view'
import Prepare from './Prepare/Prepare.view'
import ChooseDevicePage from './ChooseDevice/ChooseDevice.view';
import Package from './Packages/Package.view'
import Error404 from './Error404/Error404'
import ReservationView from './Reservation/Reservation'
import Rejoin from './Rejoin/Rejoin'
import ErrorByCase from './ErrorByCase/ErrorByCase'
import Support from './Support/Support.view'
import Contact from './Contact/Contact.view'
import PaymentHistoryView from './PaymentHistory/PaymentHistory.view'
import UserProfile from './UserProfile/UserProfile.view'
import Success from './CancelMemberShip/Success'
import Error from './CancelMemberShip/Error'
import EditUserProfile from './EditUserProfile/EditUserProfile.view'
import Referer from './Referer/Referer'
import MyRecord from './MyRecord/MyRecord.view'

export const Views = {
    Landing,
    Prepare,
    ChooseDevicePage,
    Package,
    Error404,
    ReservationView,
    Rejoin,
    ErrorByCase,
    Support,
    Contact,
    PaymentHistoryView,
    UserProfile,
    Success,
    Error,
    EditUserProfile,
    Referer,
    MyRecord
}